module.exports = __webpack_public_path__ + "static/img/todo.35f1c18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/todo.png
// module id = G26t
// module chunks = 1